var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9219 2.0587L17.9411 7.07864C18.0196 7.1569 18.0196 7.28504 17.9411 7.36357L16.2317 9.07274C16.1533 9.15139 16.0252 9.15139 15.947 9.07274L15.461 8.58701L13.208 10.8399C13.7135 12.7438 13.2204 14.8581 11.7275 16.3509C11.6929 16.3858 11.6579 16.4198 11.6223 16.4533C11.4916 16.5777 11.5126 16.5769 11.3863 16.4506L8.19756 13.2616L2 18L6.73948 11.8035L3.5461 8.61005C3.41876 8.48244 3.42944 8.50249 3.5547 8.37084C3.58595 8.33815 3.61785 8.30533 3.65027 8.27278C5.14286 6.78004 7.25732 6.2865 9.16098 6.79215L11.4137 4.5393L10.9277 4.05331C10.8494 3.97505 10.8494 3.84691 10.9277 3.76839L12.6369 2.0587C12.7156 1.98043 12.8437 1.98043 12.9219 2.0587Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ec3bd8d4b0004454e91d519214baed05.svg";
export { ForwardRef as ReactComponent };